import { LayerCloseHandleV2, LayerHandleV2, LayerManagerV2, RenderFunctionV2 } from '@volkswagen-onehub/layer-manager';
import React, { Suspense } from 'react';
import { Modal } from '../../models/Modal';

// Helper to create the renderFunction with our ReactComponent for the Layer Feature Service
function modalHelper<Props>(overlay: (props: Modal<Props>) => JSX.Element): RenderFunctionV2<Props, any> {
	return (state: Props, close: LayerCloseHandleV2<any>): JSX.Element => {
		return <Suspense fallback> {overlay({ state, close })} </Suspense>;
	};
}

// can not be used with React Hooks look at Vehicle Verification for example for implementation with Hooks
export function openContentLayer<Props>(
	layerManager: LayerManagerV2,
	overlay: (props: Modal<Props>) => JSX.Element,
	state: Props,
	options?: any,
): LayerHandleV2<Props> {
	return layerManager.openContentLayerV2(modalHelper<Props>(overlay), state, options || { userCloseable: false });
}
